module.exports = {"id":"218433","name":"Federico Vega","rating":"71","photo":"./data/images/photos/2/218433.png","club":{"name":"Lorca Deportiva","logo":"./data/images/clubs/LorcaDeportiva.png"},"positions":["DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FedericoVega0.json
// module id = 1391
// module chunks = 0